export var Lease;
(function (Lease) {
    let type;
    (function (type) {
        type["LEASE"] = "Lease";
    })(type = Lease.type || (Lease.type = {}));
})(Lease || (Lease = {}));
